import { SelectHTMLAttributes, forwardRef } from 'react';
import cx from 'classnames';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
  children: React.ReactNode;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ error, className, children, disabled, ...props }, ref) => {
    return (
      <select
        ref={ref}
        disabled={disabled}
        className={cx(
          'w-full px-4 py-2.5 rounded-lg transition-colors duration-200',
          'bg-white dark:bg-gray-800',
          'border text-foreground',
          'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          // Style option elements for dark mode
          '[&_option]:bg-white [&_option]:dark:bg-gray-800',
          '[&_option]:text-foreground',
          {
            'border-gray-300 dark:border-gray-700': !error,
            'border-error-600 dark:border-error-500': error,
          },
          className
        )}
        {...props}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';
